import { BattleScene } from './scenes/battle-scene/BattleScene';

import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";
import { BattleManager } from './scenes/battle-scene/BattleManager';

export class Game extends Phaser.Game {

    public static currentInstance: Phaser.Game;

    constructor(config: Phaser.Types.Core.GameConfig, reactClass?: any) {
        
        super(config);
      
        Game.currentInstance = this;

        if (this.device.os.iPhone) {
            setInterval(function(): void {
                if (document.hasFocus()) {

                    if (AudioManager.sound) {
                        AudioManager.sound.mute(GameVars.gameData.soundMuted);
                    }
            
                    if (AudioManager.music) {
                        AudioManager.music.mute(GameVars.gameData.musicMuted);
                    }

                } else {

                    if (AudioManager.sound) {
                        AudioManager.sound.mute(true);
                    }
            
                    if (AudioManager.music) {
                        AudioManager.music.mute(true);
                    }
                    
                }
            }, 100);
        }
    }

    protected onBlur(): void {

        if (AudioManager.sound) {
            AudioManager.sound.mute(true);
        }

        if (AudioManager.music) {
            AudioManager.music.mute(true);
        }

        if (BattleScene.currentInstance) {
            BattleManager.onClickMenu();
        }
    }

    protected onFocus(): void {

        if (AudioManager.sound) {
            AudioManager.sound.mute(GameVars.gameData.soundMuted);
        }

        if (AudioManager.music) {
            AudioManager.music.mute(GameVars.gameData.musicMuted);
        }
    }
}
